/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AvailabilitySchedule } from './availabilitySchedule';
import { AvailabilityWindow } from './availabilityWindow';


import {ValidatorFn, Validators} from "@angular/forms";

export interface ScheduleCreateResult { 
    schedules: Array<AvailabilitySchedule>;
    windows: Array<AvailabilityWindow>;
}
export const ScheduleCreateResult_schedules_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const ScheduleCreateResult_windows_Validators: ValidatorFn[] =
    [  Validators.required, ];


